// extracted by mini-css-extract-plugin
export default {"tableContainer":"table_tableContainer__+e+92","table":"table_table__hFA46"};